module.exports = __webpack_public_path__ + "video_c.a761126c.png";